// extracted by mini-css-extract-plugin
export default {"checkbox":"Toggler_checkbox__uC50-","disabled":"Toggler_disabled__C7rGi"};